<template>
  <v-list nav dense>
    <v-list-item
      v-for="(item, key) in items"
      :key="key"
      link
      :to="item.route"
      active-class="white--text"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-list-item-content v-on="on">
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </v-list-item>
  </v-list>
</template>
<script>
const API_ENDPOINT = "/api/routing";
export default {
  data: () => ({
    items: []
  }),
  methods: {
    getGenSetup() {
      this.$axios
        .get(`${API_ENDPOINT}/gen`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  created() {
    this.getGenSetup();
  }
};
</script>